<template>
    <header class="header">
        <div class="container">
            <h1 class="header__title c--dark">Community</h1>
        </div>
    </header>
</template>

<script>
export default {
name: "chatHeader"
}
</script>
